import {WellnessCarousel} from "@irati/types"
import Button from "@irati/ui/src/Button"
import Hero from "@irati/ui/src/Hero"
import {H2} from "@irati/ui/src/Typography"
import React from "react"
import {getResourceByType} from "../../utils"
import MediaLink from "./MediaLink"
import {Content, Description} from "./styled"

type Props = {
  media: WellnessCarousel
  onClick?: () => void
}

const HeroMedia = ({media, onClick = () => {}}: Props) => {
  const {title, subtext, backgroundImage, ctaText, ctaType, ctaResource, textColor} = media
  const url = getResourceByType(ctaType!, ctaResource!)

  return (
    <MediaLink ctaType={ctaType!} url={url} onClick={onClick}>
      <Hero bgImg={backgroundImage!}>
        <Content color={textColor}>
          <H2 marginBottom={1}>{title}</H2>
          <Description>{subtext}</Description>
          <Button primary marginTop={2}>
            {ctaText}
          </Button>
        </Content>
      </Hero>
    </MediaLink>
  )
}
export default HeroMedia
